












import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { getUserById } from '@/utils/user';
import { timeFormat } from '@/utils/other';

const columns = [
  {
    slots: { title: 'userTitle' },
    dataIndex: 'userId',
    scopedSlots: { customRender: 'user' },
  },
  {
    slots: { title: 'messageTitle' },
    dataIndex: 'message',
    ellipsis: true,
  },
  {
    slots: { title: 'timeTitle' },
    dataIndex: 'dateTime',
    scopedSlots: { customRender: 'time' },
  },
];

@Component({
  filters: {
    timeFormat,
  },
})
export default class LogModal extends Vue {
  private columns = columns;
  private getUserById = getUserById;
  get visible() {
    return AppModule.logModal.visible;
  }
  get logs() {
    return AppModule.logModal.logs;
  }
  private onClose() {
    AppModule.ToggleLogModal();
  }
}
